import { render, staticRenderFns } from "./SubmitalAdmin.vue?vue&type=template&id=2d5aa850&scoped=true&"
import script from "./SubmitalAdmin.vue?vue&type=script&lang=js&"
export * from "./SubmitalAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SubmitalAdmin.vue?vue&type=style&index=0&id=2d5aa850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5aa850",
  null
  
)

export default component.exports